import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Service {
  icon: string;
  title: string;
  description: string;
  link?: string;
}

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const services = [
    {
      title: 'Tagliandi',
      description: 'Tagliandi completi per auto e moto con ricambi originali o equivalenti di qualità.',
      icon: 'ri-tools-line',
      link: '/tagliandi'
    },
    {
      title: 'Impianto Frenante',
      description: 'Controllo e sostituzione pastiglie, dischi freno e liquido freni per la tua sicurezza.',
      icon: 'ri-speed-line',
      link: '/impianto-frenante'
    },
    {
      title: 'Diagnosi',
      description: 'Diagnosi elettronica completa con strumenti professionali per individuare ogni problema.',
      icon: 'ri-cpu-line',
      link: '/diagnosi'
    },
    {
      title: 'Manutenzione',
      description: 'Manutenzione ordinaria e straordinaria per mantenere il tuo veicolo sempre efficiente.',
      icon: 'ri-settings-3-line',
      link: '/manutenzione'
    }
  ];

  return (
    <section id="servizi" className="py-12 sm:py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block mb-3 md:mb-4">
            <span className="inline-block px-4 sm:px-6 py-2 border-2 border-black bg-black/5 text-black font-bold text-xs tracking-widest rounded-full uppercase">
              I Nostri Servizi
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-6xl font-bold text-black mb-4 md:mb-6">
            Tutto Ciò di Cui<br />Hai Bisogno
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed px-2">
            Offriamo una gamma completa di servizi di manutenzione per auto e moto, direttamente a casa tua o in ufficio.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {services.map((service, index) => {
            const CardContent = (
              <>
                {/* Icon */}
                <div className={`w-12 sm:w-14 md:w-16 h-12 sm:h-14 md:h-16 rounded-full flex items-center justify-center mb-4 md:mb-6 transition-all duration-300 ${
                  hoveredIndex === index 
                    ? 'bg-white' 
                    : 'bg-[#E31E24]'
                }`}>
                  <i className={`${service.icon} text-xl sm:text-2xl md:text-3xl transition-all duration-300 ${
                    hoveredIndex === index 
                      ? 'text-[#E31E24]' 
                      : 'text-white'
                  }`}></i>
                </div>

                {/* Content */}
                <h3 className={`text-lg sm:text-xl font-bold mb-3 md:mb-4 transition-all duration-300 ${
                  hoveredIndex === index ? 'text-white' : 'text-black'
                }`}>
                  {service.title}
                </h3>
                <p className={`text-sm sm:text-base leading-relaxed mb-4 md:mb-6 transition-all duration-300 ${
                  hoveredIndex === index ? 'text-white/90' : 'text-gray-600'
                }`}>
                  {service.description}
                </p>

                {/* Link */}
                <div className={`text-sm font-semibold transition-all duration-300 ${
                  hoveredIndex === index ? 'text-[#E31E24]' : 'text-[#E31E24]'
                }`}>
                  Scopri di più <i className="ri-arrow-right-line ml-1"></i>
                </div>
              </>
            );

            return service.link ? (
              <Link
                key={index}
                to={service.link}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className={`group relative bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 md:p-10 transition-all duration-300 cursor-pointer block ${
                  hoveredIndex === index 
                    ? 'bg-black shadow-2xl shadow-[#E31E24]/20 -translate-y-2' 
                    : 'hover:shadow-lg'
                }`}
              >
                {CardContent}
              </Link>
            ) : (
              <div
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className={`group relative bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 md:p-10 transition-all duration-300 cursor-pointer ${
                  hoveredIndex === index 
                    ? 'bg-black shadow-2xl shadow-[#E31E24]/20 -translate-y-2' 
                    : 'hover:shadow-lg'
                }`}
              >
                {CardContent}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
